import * as React from "react";

interface RibbonHeaderProps {
  text?: string;
  future?: boolean;
}

const RibbonHeader = ({
  text,
  future = false,
  ...props
}: RibbonHeaderProps) => {
  const textLength = text ? text.length : 0;
  const width = Math.max(360, 30 + textLength * 16);
  
  return (
    <svg
      width={width}
      height={76}
      viewBox={`0 0 ${width} 76`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d={`M0 8C0 3.58172 3.58172 0 8 0H${width-8}C${width-3.582} 0 ${width} 3.58172 ${width} 8V48C${width} 52.4183 ${width-3.582} 56 ${width-8} 56H0V8Z`}
        fill={future ? "#80089D" : "#F2E6F5"}
      />
      <text
        x={width/2}
        y="30"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="32"
        fontWeight="600"
        letterSpacing="1px"
        fill={future ? 'white' : '#262626'}      >
        {text}
      </text>

      <path
        d="M0 56H5V66C2 63 0 61.6297 0 58.7059V56Z"
        fill={future ? "#80089D" : "#F2E6F5"}
      />
      <path
        d="M1 60.2655C1 57.9097 2.90973 56 5.26549 56H16V76C16 76 8.77517 70.0106 4.5 65.5C2.93513 63.8489 1 62.4034 1 60.2655Z"
        fill={future ? "#4D055E" : "#E1A8F0"}
      />
    </svg>
  );
};
export default RibbonHeader;